<script>
    export let value = null
    export let label = null
    export let required = false
    export let disabled = false
    export let validation = null
    export let name = null
    export let style = ''
    export let valid = null
    export let placeholder = ''
    export let options = []
    export let currentIndex = null
    import { Typography } from './'
    import { clickOutside } from '$lib/utils'
    import ScrollBox from './ScrollBox.svelte'
    import { getContext, onMount, onDestroy } from 'svelte'
    import slide from '../../custom/animations/slide'
    import { ChevronDown } from '../Icons'
    import { createEventDispatcher } from 'svelte'
    let toggle = false
    let display = null
    let viewport = null
    let vp = { height: 0, width: 0 }
    const dispatch = createEventDispatcher()
    function onchange() {
        dispatch('change', {})
    }
    function formatOptions() {
        let type = options.length > 0 ? typeof options[0] : null
        let tmp = type ? options.filter((x) => typeof x === type) : []
        if (type) {
            if (type === 'string') {
                options = tmp.map((x) => {
                    return { label: x, value: x }
                })
            } else if (type === 'object' && tmp[0] instanceof Array) {
                options = tmp.map((x) => {
                    return { label: x[1], value: x[0] }
                })
            } else {
                options = tmp
            }
        }
    }
    function keypress(event) {
        if (['Enter', 'Space'].indexOf(event.code) !== -1 && !toggle) {
            toggle = true
        } else if (event.code === 'Escape') {
            toggle = false
        } else if (event.code === 'ArrowDown') {
            event.preventDefault()
            if (currentIndex + 1 < options.length && !disabled) {
                currentIndex++
            }
        } else if (event.code === 'ArrowUp' && !disabled) {
            event.preventDefault()
            if (currentIndex - 1 >= 0) {
                currentIndex--
            }
        }
    }
    function indexChangeBuilder(ind) {
        return (_) => {
            currentIndex = ind
        }
    }
    let formData = getContext('formData')
    onMount((_) => {
        formatOptions()
        if (currentIndex !== null && currentIndex < options.length) {
            display = options[currentIndex].label
            value = options[currentIndex].value
        }
    })
    $: if (value) valid = value && validation ? validation(value) : null
    $: if (!disabled) toggle = false
    $: if (options) formatOptions()
    $: if (currentIndex || currentIndex === 0) {
        value = options[currentIndex].value
        display = options[currentIndex].label
    }
    $: if (((value && name) || name) && formData)
        formData.update((x) => {
            return Object.assign(
                x,
                Object.fromEntries([
                    [
                        name,
                        {
                            valid: !!valid,
                            validation: !!validation,
                            required,
                            value,
                            label,
                            labelOption: display,
                        },
                    ],
                ])
            )
        })
    onDestroy((_) => {
        if (((value && name) || name) && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    })
</script>

<div {style} class="box" class:disabled>
    <div
        tabindex="0"
        on:click={(_) => {
            if (!disabled) toggle = !toggle
        }}
        use:clickOutside
        on:clickout={(_) => (toggle = false)}
        on:keypress={keypress}
        on:keydown={keypress}
        style="position: relative; display: flex; cursor: pointer; justify-content: space-between; align-items: center; width: 100%"
    >
        <input type="text" disabled {placeholder} value={display} />
        <ChevronDown color={disabled ? '#CCCCCC' : '#6F7072'} />
        {#if !disabled && toggle}
            <div
                on:blur={(_) => {
                    toggle = false
                }}
                transition:slide
                class="optionBox"
                bind:this={viewport}
                bind:clientWidth={vp.width}
                bind:clientHeight={vp.height}
            >
                <ScrollBox
                    width="100%"
                    height={options.length >= 5
                        ? '235px'
                        : `${options.length * 47}px`}
                >
                    {#if options.length > 0}
                        <ul>
                            {#each options as { value: val, label: txt }, i}
                                <li
                                    tabindex="0"
                                    class={currentIndex === parseInt(`${i}`)
                                        ? 'active'
                                        : ''}
                                    on:keypress={(e) => {
                                        if (e.code === 'Enter') {
                                            indexChangeBuilder(i)()
                                            toggle = false
                                        }
                                    }}
                                    on:click={(_) => {
                                        indexChangeBuilder(i)()
                                        onchange()
                                    }}
                                >
                                    <Typography
                                        type="body"
                                        style="margin: 0; padding: 0"
                                        color="grey-800">{txt}</Typography
                                    >
                                </li>
                            {/each}
                        </ul>
                    {:else}
                        No options
                    {/if}
                </ScrollBox>
            </div>
        {/if}
    </div>
</div>

<style>
    .box {
        width: 100%;
        /* padding: 10px; */
        display: flex;
        flex-direction: column;
        user-select: none;
    }
    input[type='text'] {
        background: transparent;
        border-style: none;
        margin: 0;
        font-size: 17px;
        width: calc(100% - 5px);
        color: var(--color-black);
        outline: none;
        cursor: pointer;
        caret-color: #5496e3;
    }
    input[type='text']::placeholder {
        color: var(--color-grey-300);
    }
    /* span {
    width: 100%;
    display: flex;
  } */

    /* .error {
    border-top: 1px var(--color-accent-alert-error) solid;
    color: var(--color-accent-alert-error);
    background: var(--color-accent-alert-error-bg);
  } */

    .disabled {
        cursor: no-drop;
    }

    /* .disabled span {
    border-top: 1px var(--color-grey-300) solid;
    cursor: no-drop;
  } */

    .disabled input[type='text']:disabled {
        color: var(--color-grey-400);
    }

    .optionBox {
        width: 100%;
        position: absolute;
        min-height: 22px;
        max-height: calc(5 * 47px);
        top: calc(100% + 1px);
        background: #ffffff;
        box-shadow:
            0px 2px 4px rgba(0, 0, 0, 0.2),
            0px -1px 1px rgba(0, 0, 0, 0.02);
        z-index: 9;
        overflow-y: scroll;
    }
    .optionBox::-webkit-scrollbar {
        display: none;
    }
    .optionBox ul {
        width: 100%;
        margin: 0;
        padding: 0;
        height: auto;
        display: flex;
        flex-direction: column;
        list-style: none;
    }
    .optionBox li {
        width: 100%;
        height: 47px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        list-style: none;
        background: var(--color-white);
        transition: all 0.2s ease-in-out;
    }

    .optionBox li.active,
    .optionBox li:hover {
        background: var(--color-grey-050);
    }
</style>
